import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

import type {
  GetDecisioningStudioAgentsAppGroupIdDsaIdSegmentsResult,
  PutDecisioningStudioAgentsAppGroupIdDsaIdSegmentsResult,
} from "./types";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdSegmentsResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdDsaIdSegmentsResult>({
    segments_ids: (segmentsIds: unknown): segmentsIds is string[] =>
      arrayOf(string)(segmentsIds) && segmentsIds.length <= 1,
  });

export const isPutDecisioningStudioAgentsAppGroupIdDsaIdSegmentsResult =
  objectOf<PutDecisioningStudioAgentsAppGroupIdDsaIdSegmentsResult>({
    segments_ids: arrayOf(string),
  });
